import {DomainAncestor, entityConfig} from "../../../core/common/domain/DomainAncestor";
import {observable} from "mobx";
import {ProjectVersion} from "./projectVersionDomain";
import {ProjectVersionMaterial} from "./projectVersionMaterialDomain";
import {LovItem} from "../../../core/metamodel/mdEntity";
import {ID} from "../../../core/metamodel/metaConstant";


@entityConfig()
export default class ProjectVersionLopFilling extends DomainAncestor {

  @observable fillingId : number;
  @observable projectVersion : ProjectVersion;
  @observable name : string;
  @observable width : number;
  @observable height : number;
  @observable glazingArea : number;
  @observable glazingMaterial : LovItem<ProjectVersionMaterial>;
  @observable glazingMass : number;
  @observable floorLevel : string;
  @observable reachableByLadder : boolean;
  @observable enduranceClass : LovItem<ProjectVersionMaterial>;
  @observable acousticIsolation : number;
  @observable partiesOrientation : LovItem<ProjectVersionMaterial>;
  @observable angleAlpha : number;
  @observable angleBeta : number;
  @observable angleGama : number;
  @observable angleDelta : number;
  @observable angleEpsilon : number;
  @observable angleZeta : number;
  @observable angleEta : number;
  @observable angleShieldingZ : number;


  constructor(json: any) {
    super(json);
  }

  public getId(): ID {
    return this.fillingId;
  }

  public setId(id: ID): void {
    this.fillingId = <number>id;
  }

}



// WEBPACK FOOTER //
// ./src/sbtool/domain/project/projectVersionLopFillingDomain.ts